import { getJWT } from "../../../utils/storageService";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Contact } from "../interfaces/Contact";
import { links } from "../../../utils/links";
import useContactsStore from "../stores/useContactsStore";
import useClientChangesQuery from "../../../global/queries/useClientChangesQuery";
import { mergeChangesWithContacts } from "../../../utils/ContactChangesScripts";


const useGetContactsQuery = () => {
    const jwt = getJWT();
    const navigate = useNavigate()
    const { initContacts } = useContactsStore();

    const { data: changes } = useClientChangesQuery();

    return useQuery({
        queryKey: ['Contacts'],
        queryFn: () => axios
            .get<Contact[]>(links.getKontakte, {
                headers: { Authorization: `Bearer ${jwt}` }
            })
            .then(res => {
                let mergedContacts = res.data;
                if (changes) mergedContacts = mergeChangesWithContacts(res.data, changes);
                mergedContacts = mergedContacts.filter((contact, index, self) => {
                    return index === self.findIndex((t) => (
                        t.name === contact.name && t.suchname === contact.suchname
                    ))
                })
                console.log("mergedContacts: ", mergedContacts)
                initContacts(mergedContacts);
                return mergedContacts;
            })
            .catch(error => {
                console.log("JWT: ", jwt)
                localStorage.removeItem("jwt");
                navigate("/login")
                console.log("Error getting Contacts: ", error)
            })
    })
}

export default useGetContactsQuery;